import { useNavigate } from "react-router-dom";
import { useCallback } from "react";

/**
 * A navigate function that performs hard navigation in EN mode.
 */
export function useHardNavigate() {
  const navigate = useNavigate();

  return useCallback((to: string, options?: { replace?: boolean }) => {
    const lang = localStorage.getItem("language");
    
    if (lang === "en") {
      if (options?.replace) {
        window.location.replace(to);
      } else {
        window.location.href = to;
      }
      return;
    }
    
    navigate(to, options);
  }, [navigate]);
}
